<ng-container *transloco="let t">
  <app-category-section-header
    [title]="t(categoryLocalizationKey())"
    (showAll)="onShowAll()"
  ></app-category-section-header>
</ng-container>

<app-responsive-event-list
  [events]="events()"
></app-responsive-event-list>
